import React from "react";
import { CharacterSheet } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const ReinoCultivo: React.FC<Props> = ({ character, onChange }) => {
  const updateField = (field: keyof CharacterSheet["reinoCultivo"], value: any) => {
    onChange({
      ...character,
      reinoCultivo: {
        ...character.reinoCultivo,
        [field]: value,
      },
    });
  };

  return (
    <div className="section">
      <h2>Reino de Cultivo</h2>
      <div className="form-grid">
        <div className="form-group">
          <label>Nome do Reino</label>
          <input
            type="text"
            value={character.reinoCultivo.nome}
            onChange={(e) => updateField("nome", e.target.value)}
            placeholder="Ex: Qi Condensado"
          />
        </div>
        <div className="form-group">
          <label>Nível do Reino</label>
          <input
            type="number"
            value={character.reinoCultivo.nivel}
            onChange={(e) => updateField("nivel", parseInt(e.target.value) || 0)}
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Multiplicador</label>
          <input
            type="number"
            value={character.reinoCultivo.multiplicador}
            onChange={(e) => updateField("multiplicador", parseFloat(e.target.value) || 1)}
            min="1"
            step="0.1"
          />
        </div>
        <div className="form-group">
          <label>Limite de Atributos</label>
          <input
            type="number"
            value={character.reinoCultivo.limiteAtributos}
            onChange={(e) => updateField("limiteAtributos", parseInt(e.target.value) || 10)}
            min="1"
          />
        </div>
        <div className="form-group">
          <label>Próximo Reino</label>
          <input
            type="text"
            value={character.reinoCultivo.proximoReino}
            onChange={(e) => updateField("proximoReino", e.target.value)}
            placeholder="Ex: Fundação"
          />
        </div>
        <div className="form-group">
          <label>Preparação para Tribulação</label>
          <input
            type="text"
            value={character.reinoCultivo.preparacaoTribulacao}
            onChange={(e) => updateField("preparacaoTribulacao", e.target.value)}
            placeholder="Status da preparação"
          />
        </div>
      </div>
    </div>
  );
};
